module.exports = __webpack_public_path__ + "img/cp-08.86318b05.png";